import AbstractModelType from '../AbstractModelType';

class User extends AbstractModelType {
  #profilePk;
  #cognitoUUID;
  #firstName;
  #lastName;

  constructor(properties = {}) {
    super(...arguments);

    this.#profilePk = properties.profilePk;
    this.#cognitoUUID = properties.cognitoUUID;
    this.#firstName = properties.firstName;
    this.#lastName = properties.lastName;
  }

  get uuid() {
    // If we don't have a cognito_id, we want amplitude to yell at us in,
    // their UI, but we don't want the reader to notice.
    return this.#cognitoUUID || '00000nocognito' + this.#profilePk;
  }

  get firstName() {
    return this.#firstName;
  }

  get lastName() {
    return this.#lastName;
  }

  get name() {
    return `${this.firstName ?? ''} ${this.lastName ?? ''}`.trim();
  }

  get namePossessed() {
    return this.name?.replace(/\s/g, '') ? `${this.name}'s` : '';
  }

  /**
   * Determines whether the user created a user content item.
   *
   * @param {UserContentItem} item - a user content item
   * @returns {Boolean} whether the user created the item
   */
  created(item) {
    return item.userId === this.id;
  }
}

export default User;
